import { Grid, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import AppInfo from "./AppInfo";
import Hero from "Pages/Telematics/Hero";
import TelematicsInfo from "Pages/Telematics/TelematicsInfo";
import { apiClient } from "api/apiClient";
import Euler from "assets/euler.png";
import AppInfoReverse from "./AppInfoReverse";
import DriverNotification from "./DriverNotification";
import { COLORS } from "theme";
import JoinTheCommunity from "./JoinTheCommunity";
import { sortData } from "utils";
import { Helmet } from "react-helmet";
import MetaTags from "ReusableComponents/MetaTags/MetaTags";
import { useLanguage } from "LanguageContext";

const Telematics = () => {
  const small = useMediaQuery("(max-width: 600px)");
  const [data, setData] = useState([]);
  const [banner, setBanner] = useState([]);
  const [info, setInfo] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [multiscreens, setMultiscreens] = useState([]);
  const { selectedLanguage } = useLanguage();

  useEffect(() => {
    apiClient.getTelemetics(selectedLanguage).then((res) => {
      setData(sortData(res.data));
    });
    apiClient.getTemematicsHero(selectedLanguage).then((res) => {
      setBanner(res.data);
    });
    apiClient.getTemematicsInfo(selectedLanguage).then((res) => {
      setInfo(res.data);
    });
    apiClient.getTemematicsNotifications(selectedLanguage).then((res) => {
      setNotifications(res.data);
    });
    apiClient.getTemematicsMultiscreens(selectedLanguage).then((res) => {
      setMultiscreens(res.data);
    });
  }, []);
  return (
    <>
      <Grid item xs={12} style={{ marginTop: 71 }}>
        <Hero small={small} banner={banner} />
      </Grid>
      <Grid item xs={12}>
        <TelematicsInfo small={small} info={info} />
      </Grid>

      {data.map((item, i) => (
        <Grid item xs={12} style={{ paddingTop: 0 }} key={item.id}>
          {small ? (
            <AppInfo
              small={small}
              title={item.attributes.title}
              subtitle={item.attributes.subtitle}
              img={item?.attributes?.media?.data?.attributes?.url}
              alt={item?.attributes?.media?.data?.attributes?.alternativeText}
              list={[
                {
                  id: 1,
                  title: item?.attributes?.feature1,
                  img: item?.attributes?.feature1image?.data?.attributes?.url,
                  alt: item?.attributes?.feature1image?.data?.attributes
                    ?.alternativeText,
                },
                {
                  id: 2,
                  title: item?.attributes?.feature2,
                  img: item?.attributes?.feature2image?.data?.attributes?.url,
                  alt: item?.attributes?.feature1image?.data?.attributes
                    ?.alternativeText,
                },
                {
                  id: 3,
                  title: item?.attributes?.feature3,
                  img: item?.attributes?.feature3image?.data?.attributes?.url,
                  alt: item?.attributes?.feature1image?.data?.attributes
                    ?.alternativeText,
                },
              ]}
            />
          ) : i % 2 === 0 ? (
            <AppInfo
              small={small}
              title={item.attributes.title}
              subtitle={item.attributes.subtitle}
              img={item?.attributes?.media?.data?.attributes?.url}
              alt={item?.attributes?.media?.data?.attributes?.alternativeText}
              list={[
                {
                  id: 1,
                  title: item?.attributes?.feature1,
                  img: item?.attributes?.feature1image?.data?.attributes?.url,
                  alt: item?.attributes?.feature1image?.data?.attributes
                    ?.alternativeText,
                },
                {
                  id: 2,
                  title: item?.attributes?.feature2,
                  img: item?.attributes?.feature2image?.data?.attributes?.url,
                  alt: item?.attributes?.feature1image?.data?.attributes
                    ?.alternativeText,
                },
                {
                  id: 3,
                  title: item?.attributes?.feature3,
                  img: item?.attributes?.feature3image?.data?.attributes?.url,
                  alt: item?.attributes?.feature1image?.data?.attributes
                    ?.alternativeText,
                },
              ]}
            />
          ) : (
            <AppInfoReverse
              small={small}
              alt={item?.attributes?.media?.data?.attributes?.alternativeText}
              title={item.attributes.title}
              subtitle={item.attributes.subtitle}
              img={item?.attributes?.media?.data?.attributes?.url}
              list={[
                {
                  id: 1,
                  title: item?.attributes?.feature1,
                  img: item?.attributes?.feature1image?.data?.attributes?.url,
                  alt: item?.attributes?.feature1image?.data?.attributes
                    ?.alternativeText,
                },
                {
                  id: 2,
                  title: item?.attributes?.feature2,
                  img: item?.attributes?.feature2image?.data?.attributes?.url,
                  alt: item?.attributes?.feature1image?.data?.attributes
                    ?.alternativeText,
                },
                {
                  id: 3,
                  title: item?.attributes?.feature3,
                  img: item?.attributes?.feature3image?.data?.attributes?.url,
                  alt: item?.attributes?.feature1image?.data?.attributes
                    ?.alternativeText,
                },
              ]}
            />
          )}
        </Grid>
      ))}

      <Grid
        item
        xs={12}
        style={{ paddingTop: 0, background: COLORS.lightBlack }}
      >
        <DriverNotification small={small} notifications={notifications} />
      </Grid>
      <Grid item xs={12} style={{ paddingTop: 0 }}>
        <JoinTheCommunity small={small} multiscreens={multiscreens} />
      </Grid>
      <Helmet>
        <title>
          EV Fleets - Euler Shepherd Electric Vehicle Tracking Solutions | Euler
          Motor
        </title>
        <link rel="canonical" href="https://www.eulermotors.com/en/vehicle-intelligence" />
        <link rel="canonical" href="https://www.eulermotors.com/hi/vehicle-intelligence" />
        <link rel="canonical" href="https://www.eulermotors.com/ta/vehicle-intelligence" />
        <link rel="canonical" href="https://www.eulermotors.com/te/vehicle-intelligence" />
        <link rel="canonical" href="https://www.eulermotors.com/mr/vehicle-intelligence" />
        <link rel="canonical" href="https://www.eulermotors.com/gu/vehicle-intelligence" />
        <link rel="canonical" href="https://www.eulermotors.com/kn/vehicle-intelligence" />
        <link rel="canonical" href="https://www.eulermotors.com/bn/vehicle-intelligence" />
       
        <link
          rel="publisher"
          href="https://www.eulermotors.com/vehicle-intelligence"
        />
        <meta
          name="title"
          content="EV Fleets - Euler Shepherd Electric Vehicle Tracking Solutions | Euler Motors"
        />
        <meta
          name="description"
          content="Euler Shepherd provides EV Fleets control at your fingertips. Euler Shepherd is a vehicle tracking system on mobile application as well as web platform that gives you real-time tracking updates about your fleet operations."
        />
        ​
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.eulermotors.com/vehicle-intelligence"
        />
        <meta
          property="og:title"
          content="EV Fleets - Euler Shepherd Electric Vehicle Tracking Solutions | Euler Motors"
        />
        <meta
          property="og:description"
          content="Euler Shepherd provides EV Fleets control at your fingertips. Euler Shepherd is a vehicle tracking system on mobile application as well as web platform that gives you real-time tracking updates about your fleet operations."
        />
        <meta property="og:image" content={Euler} />
        ​
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://www.eulermotors.com/vehicle-intelligence"
        />
        <meta
          property="twitter:title"
          content="EV Fleets - Euler Shepherd Electric Vehicle Tracking Solutions | Euler Motors"
        />
        <meta
          property="twitter:description"
          content="Euler Shepherd provides EV Fleets control at your fingertips. Euler Shepherd is a vehicle tracking system on mobile application as well as web platform that gives you real-time tracking updates about your fleet operations."
        />
        <meta property="twitter:image" content={Euler} />
        <MetaTags link={"https://www.eulermotors.com/vehicle-intelligence"} />
      </Helmet>
    </>
  );
};

export default Telematics;
